module.exports = __webpack_public_path__ + "static/media/feat_barons.c7707dd7.png";